<div class="main-wrapper">
  <section class="signup-section accounts-tab" *ngIf="accountsData.content">
  <div *ngIf='initModal'>
    <app-modal [showModal]="initModal" [modalClass]="modalClass">
      <div>
        <div class="modal-header">
          <h2>{{accountsData.content['PopMsg'+modalMsg].heading}}</h2>
        </div>
        <div class="corner-button">
          <!-- Changing route from learn to home as part of US-1367 -->
          <button routerLink="/learn" aria-label="Close" class="close">x</button>
        </div>
        <div class="box-outer">
          <p>{{accountsData.content['PopMsg'+modalMsg].subheading}}</p>
          <p>{{accountsData.content['PopMsg'+modalMsg].description}}</p>
        </div>
        <div class="text-right modal-footer">
          <div class="button-group">
            <!-- Changing route from learn to home as part of US-1367 -->
            <a routerLink="/learn" class="btn btn-secondary">{{accountsData.content['PopMsg'+modalMsg].buttonLabel}}</a>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </app-modal>
  </div>
  <div *ngIf="showError" id="alertMessage" class="alert valign-children-middle">
    <div class="alert-error" role="img" aria-label="Alert">
      <i class="icon-badgealert"></i>
    </div>
    <div>
        <span *ngIf="showGoogleCreationError">{{errorMessage}}&nbsp;<a href="#" (click)="backToProductSelection($event)">{{accountsData.content.errorMessageGoogle.productSelectionPageLink}}</a>&nbsp;{{accountsData.content.errorMessageGoogle.apiErrorDesc}}</span>
      <span *ngIf="!showGoogleCreationError && showError">{{errorMessage}}</span>
    </div>
  </div>

  <section *ngIf="haveAccordion" class="backFromSettingsAccordion">
    <h2>{{pageTitle}}</h2>
    <span [innerHTML]= "pageDescription"></span>
    <a target="_blank" href="http://serviceguidenew.att.com/sg_flashPlayerPage/IBM_MaaS360">
      {{pageLink}}
    </a>
    {{pageDescription2}} 
    <app-accordion [accordion]="tabArray" [accordionController]=f alse>
      <app-accordion-list *ngFor="let option of tabArray; let i = index" [option]='option' [isSubAccordion]=true>
        <p>{{accountsData.content.backFromSettings.subheading}}</p>
        <app-customgrid [gridOptions]="gridOptions[i]" (onDataChange)="onRowClick($event)"></app-customgrid>
      </app-accordion-list>
    </app-accordion>
    <div class="agreement">
      <h3>{{accountsData.content.termsAndCondition.legalAgreement}}</h3>
      <div *ngIf='this.mdm'>{{accountsData.content.termsAndCondition.attTerms}}
        {{accountsData.content.termsAndCondition.attTerms2}}
        <a target="_blank" [href]="termscondURl">
        {{accountsData.content.termsAndCondition.link2}}</a>.
        <p class="termsServiceText" [innerHTML]="accountsData.content.termsAndCondition.termsServiceText"></p>
         <a target="_blank" [href]="staticTcUrl">{{accountsData.content.termsAndCondition.ibmCloudLink}}</a>
          {{accountsData.content.termsAndCondition.termsServiceText2}}
        <a [href]="guideUrl" target="_blank"> {{accountsData.content.termsAndCondition.termsIBMLink}}</a>.
        </div>
      <p *ngIf='this.ztp'>{{accountsData.content.termsAndCondition.attTerms}}
        {{accountsData.content.termsAndCondition.attTerms2}}
        <a target="_blank" [href]="termscondURl"> {{accountsData.content.termsAndCondition.link3}}</a>.
         {{accountsData.content.termsAndCondition.description5}}
         <a target="_blank" [href]="staticTcUrl">{{accountsData.content.termsAndCondition.link4}}</a>.
      </p>
      <p *ngIf='this.kme'>{{accountsData.content.termsAndCondition.attTerms}}
        {{accountsData.content.termsAndCondition.attTerms2}}
        <a target="_blank" [href]="termscondURl"> {{accountsData.content.termsAndCondition.link3}}</a>.
         {{accountsData.content.termsAndCondition.description6}}
         <a target="_blank" [href]="staticTcUrl">{{accountsData.content.termsAndCondition.link4}}</a>.
      </p>
    </div>
    <section class="buttons-section col-sm-12 col-md-12  text-right">
      <button [disabled]="selectedFanList === 0" aria-label="Continue." (click)="continueToNext()" href="javascript:void(0)" class="btn btn-secondary pull-right">{{accountsData.content.buttons.continue}}</button>
      <a href="#" (click)="backToInitialSetup($event)" class="btn btn-link btn-block btn-cancel">{{accountsData.content.buttons.cancel}}</a>
    </section>
  </section>

  <section [attr.id]="initialSignup ? 'Add-accounts' : ''" class="signupwithnotab" *ngIf="!haveTab && !haveAccordion">
    <div>
      <h2>{{pageTitle}}</h2>
      <p *ngIf="ztp || kme || (mdm && !initialSignup)">
        <span [innerHTML]="pageDescription"></span>
        <span *ngIf="mdm">
          <a target="_blank" href="http://serviceguidenew.att.com/sg_flashPlayerPage/IBM_MaaS360" *ngIf="accountsData.content.noTabawaitingSignupFanList.link">
            {{accountsData.content.noTabawaitingSignupFanList.link}}
          </a>
        <span *ngIf="accountsData.content.noTabawaitingSignupFanList.description2">
          {{accountsData.content.noTabawaitingSignupFanList.description2}}
        </span>
      </span>
    </p>
    <div class="link-to-brief">
      <p>
        <a href="assets/pdf/GoogleZTP.pdf" target="_blank" *ngIf="ztp">link to product page with product briefs</a>
        <a href="assets/pdf/SamsungKnoxMobileEnrollment.pdf" target="_blank" *ngIf="kme">link to product page with product briefs</a>
      </p>
    </div>
    <!-- <p *ngIf="mdm && initialSignup">
        <span [innerHTML]="accountsData.content.noTabawaitingSignupFanList.newDescription[0]"></span><br>
        <strong>{{accountsData.content.noTabawaitingSignupFanList.newDescription[1]}}</strong>
        {{accountsData.content.noTabawaitingSignupFanList.newDescription[2]}}
        <strong>{{accountsData.content.noTabawaitingSignupFanList.newDescription[3]}}</strong>
        <span [innerHTML]="accountsData.content.noTabawaitingSignupFanList.newDescription[4]"></span>
        <a target="_blank" href="http://serviceguidenew.att.com/sg_flashPlayerPage/IBM_MaaS360" *ngIf="accountsData.content.noTabawaitingSignupFanList.link">
          <span [innerHTML]="accountsData.content.noTabawaitingSignupFanList.newDescription[5]"></span>
        </a>
    </p> -->
      <p>{{accountsData.content.selectedFans}}</p>
    </div>
    <app-customgrid [gridOptions]="gridOptions[0]" (onDataChange)="onRowClick($event)"></app-customgrid>
    <div *ngIf="selectedFanList" class="accounts">{{accountsData.content.selectedFans}}</div>
    <!-- <section *ngIf="initialSignup" class="terms-of-service-container">

      <div class="agreement">
        <h2>{{accountsData.content.termsAndCondition.legalAgreement}}</h2>
        <div class="attTerms">
          <div>
            <span [innerHTML]="accountsData.content.termsAndCondition.attTerms"></span>
            <a target="_blank" href="https://www.wireless.att.com/businesscenter/legal-contracts/cda.jsp">{{accountsData.content.termsAndCondition.attTermsLink}}</a>
          </div>
        </div>
        <div class="ibmTerms">
          <div>{{accountsData.content.termsAndCondition.ibmTerms}}
            <a href="https://www-01.ibm.com/software/passportadvantage/pa_agreements.html and https://www-05.ibm.com/support/operations/files/pdf/csa_us.pdf">{{accountsData.content.termsAndCondition.ibmCloudLink}}</a>
            <span>{{accountsData.content.termsAndCondition.ibmTerms2}}</span>
            <a href="http://serviceguidenew.att.com/sg_CustomPreviewer?attachmentId=00P1A000010y466UAA">{{accountsData.content.termsAndCondition.ibmServiceLink}}</a>
          </div>
        </div>
      </div> -->
    <!--  <div class="agreement">
        <h2>{{accountsData.content.termsAndCondition.legalAgreement}}</h2>
        <p>{{accountsData.content.termsAndCondition.legalAgreementDescription}}.</p>
        <a href="/terms">{{accountsData.content.termsAndCondition.ToSLinkLabel}}</a>
      </div>
      <div class="check">
        <div class="checkbox" [ngClass]="{'error-text': showError && !signupOutputData.readTnC}">
          <label for="terms">
          <input (change)="signupOutputData.readTnC = !signupOutputData.readTnC" id="terms" type="checkbox"/><i class="skin"></i><span [ngClass]="{'error-text': error }">{{accountsData.content.termsAndCondition.ToS}}</span>
        </label>
        </div>
        <div class="checkbox">
          <label for="condition">
          <input (change)="signupOutputData.emailTnC = !signupOutputData.emailTnC" id="condition" type="checkbox" /><i class="skin"></i><span>{{accountsData.content.termsAndCondition.emailTermsandConditions}}</span>
        </label>
        </div>
      </div> -->
    <!-- </section> -->
    <div class="agreement">
      <h3>{{accountsData.content.termsAndCondition.legalAgreement}}</h3>
      <div *ngIf='this.mdm'>{{accountsData.content.termsAndCondition.attTerms}}
        {{accountsData.content.termsAndCondition.attTerms2}}
        <a target="_blank" [href]="termscondURl">
        {{accountsData.content.termsAndCondition.link2}}</a>.  
        <p class="termsServiceText" [innerHTML]="accountsData.content.termsAndCondition.termsServiceText"></p>
         <a target="_blank" [href]="staticTcUrl">{{accountsData.content.termsAndCondition.ibmCloudLink}}</a>
          {{accountsData.content.termsAndCondition.termsServiceText2}}
        <a [href]="guideUrl" target="_blank"> {{accountsData.content.termsAndCondition.termsIBMLink}}</a>.
        </div>
      <p *ngIf='this.ztp'>{{accountsData.content.termsAndCondition.attTerms}}
        {{accountsData.content.termsAndCondition.attTerms2}}
        <a target="_blank" [href]="termscondURl"> {{accountsData.content.termsAndCondition.link3}}</a>.
         {{accountsData.content.termsAndCondition.description5}}
         <a target="_blank" [href]="staticTcUrl">{{accountsData.content.termsAndCondition.link4}}</a>.
      </p>
      <p *ngIf='this.kme'>{{accountsData.content.termsAndCondition.attTerms}}
        {{accountsData.content.termsAndCondition.attTerms2}}
        <a target="_blank" [href]="termscondURl"> {{accountsData.content.termsAndCondition.link3}}</a>.
         {{accountsData.content.termsAndCondition.description6}}
         <a target="_blank" [href]="staticTcUrl">{{accountsData.content.termsAndCondition.link4}}</a>.
      </p>
    </div>
    <section class="buttons-section col-sm-12 col-md-12  text-right">
      <button id="accounts-btn" [checkImpersonator]="selectedFanList === 0 || showError" *ngIf="initialSignup" (click)="continueToNext()" href="javascript:void(0)"
        class="btn btn-secondary pull-right">{{accountsData.content.buttons.addAccounts}}</button>
      <button [disabled]="selectedFanList === 0 || showError" *ngIf="!initialSignup" (click)="continueToNext()" aria-label="Continue."
        href="javascript:void(0)" class="btn btn-secondary pull-right">{{accountsData.content.buttons.continue}}</button>
      <a href="#" (click)="backToInitialSetup($event)" class="btn btn-link btn-block btn-cancel">{{accountsData.content.buttons.cancel}}</a>
    </section>
  </section>
    <div *ngIf="showOverviewModal">
        <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass">
          <div class="model-cover terms">
            <div class="model-box">
              <div class="modal-header">
                <div class="corner-button">
                  <button class="close" aria-label="Close" (click)="closeOverviewModal()">x</button>
                </div>
                <att-gvp [attr.video]="videoId"></att-gvp>
              </div>
            </div>
          </div>
        </app-modal>
      </div>
  <section class="signuptabcontainer" *ngIf="haveTab">
    <app-tabs [tabs]="tabArray" [ariaLabel]="'Device enrollment'">
      <app-tab class="app-tab" *ngFor='let td of tabArray; let i = index;' [option]="td" (click)="selectedTab(i);">
        <div>
          <h2>{{pageTitle}}</h2>
          <p>{{pageDescription}}</p>
          <p *ngIf="!selectedFansCount[i]">{{accountsData.content.selectedFans}}</p>
          <p *ngIf="selectedFansCount[i]">{{selectedFansCount[i]}}</p>
        </div>
        <app-customgrid *ngIf="td.isActive" [gridOptions]="gridOptions[i]" (onDataChange)="onRowClick($event)"></app-customgrid>
        <div class="accounts" *ngIf="!selectedFansCount[i]">{{accountsData.content.selectedFans}}</div>
        <div class="accounts" *ngIf="selectedFansCount[i]">{{selectedFansCount[i]}}</div>
        <section *ngIf="td.name === 'awaitingSignupFanList'" class="terms-of-service-container">
          <div class="agreement">
            <h3>{{accountsData.content.termsAndCondition.termsService}}</h3>
            <div class="attTerms">
              <div class="awaitAttTerms">{{accountsData.content.termsAndCondition.attTerms}}
                  {{accountsData.content.termsAndCondition.attTerms2}}
                  <a target="_blank" [href]="termscondURl">
                  {{accountsData.content.termsAndCondition.link2}}</a>.
                  <p class="termsServiceText" [innerHTML]="accountsData.content.termsAndCondition.termsServiceText"></p>
                   <a target="_blank" [href]="staticTcUrl">{{accountsData.content.termsAndCondition.ibmCloudLink}}</a>
                    {{accountsData.content.termsAndCondition.termsServiceText2}}
                  <a [href]="guideUrl" target="_blank"> {{accountsData.content.termsAndCondition.termsIBMLink}}</a>.
                </div>         
              <!-- <p class="termsServiceText" [innerHTML]="accountsData.content.termsAndCondition.termsServiceText"></p> -->
                <!-- {{accountsData.content.termsAndCondition.termsServiceTextSub}} -->
                 <!-- <a target="_blank" [href]="staticTcUrl">{{accountsData.content.termsAndCondition.ibmCloudLink}}</a>
                  {{accountsData.content.termsAndCondition.termsServiceText2}}
                <a [href]="guideUrl" target="_blank"> {{accountsData.content.termsAndCondition.termsIBMLink}}</a>.
               -->
            </div>

            <!--  <p>{{accountsData.content.termsAndCondition.legalAgreementDescription}}.</p>
            <a routerLink="/terms">{{accountsData.content.termsAndCondition.ToSLinkLabel}}</a> -->
          </div>
          <!--  <div class="check" >
            <div class="checkbox" [ngClass]="{'error-text': showError && !signupOutputData.readTnC}">
              <label for="terms">
              <input (change)="signupOutputData.readTnC = !signupOutputData.readTnC" id="terms" type="checkbox"/><i class="skin"></i><span [ngClass]="{'error-text': error }">{{accountsData.content.termsAndCondition.ToS}}</span>
            </label>
            </div>
            <div class="checkbox">
              <label for="condition">
              <input (change)="signupOutputData.emailTnC = !signupOutputData.emailTnC" id="condition" type="checkbox" /><i class="skin"></i><span>{{accountsData.content.termsAndCondition.emailTermsandConditions}}</span>
            </label>
            </div>
          </div>  -->

        </section>
        <section class="buttons-section col-sm-12 col-md-12 text-right">
          <!--<button [disabled]="selectedFanList === 0" *ngIf="td.name == 'awaitingSignupFanList'" (click)="continueToNext()" href="javascript:void(0)" class="btn btn-secondary pull-right">{{accountsData.content.buttons.signupNContinue}}</button>
          <button [disabled]="selectedFanList === 0" *ngIf="td.name != 'awaitingSignupFanList'" (click)="continueToNext()" href="javascript:void(0)" class="btn btn-secondary pull-right">{{accountsData.content.buttons.continue}}</button> -->
          <button [disabled]="selectedFanList === 0 || showError || !selected.newSetupFanList" *ngIf="td.name == 'newSetupFanList'" (click)="continueToNext()" href="javascript:void(0)"
            class="btn btn-secondary pull-right">{{accountsData.content.buttons.continue}}</button>
            <button [disabled]="selectedFanList === 0 || showError || !selected.revisedFanList" *ngIf="td.name == 'revisedFanList'" (click)="continueToNext()" href="javascript:void(0)"
              class="btn btn-secondary pull-right">{{accountsData.content.buttons.continue}}</button>
              <button id="accounts-btn" [checkImpersonator]="selectedFanList === 0 || showError || !selected.awaitingSignupFanList" *ngIf="td.name == 'awaitingSignupFanList'" (click)="continueToNext()" href="javascript:void(0)"
              class="btn btn-secondary pull-right">{{accountsData.content.buttons.continue}}</button>
              <a href="#" (click)="backToInitialSetup($event)" class="btn btn-link bt-block btn-cancel">{{accountsData.content.buttons.cancel}}</a>
        </section>

      </app-tab>
    </app-tabs>
  </section>
  <div class="accordion-section" *ngIf="!prodFlag && supportArticle">
      <app-accordion [accordion]="helpArticles" [accordionController]=false>
          <app-accordion-list *ngFor="let option of helpArticles; let i=index " [option]='option' [isSubAccordion]=true>
            <div class="support-content mediaStop" id="player" *ngFor="let article of this.article.availableArticle; let i=index">
              <!-- <a href="javascript:void(0)"  (click)="getSupportContent(i)" >{{article.name}}</a> -->
              <att-gvp *ngIf="article.url" [attr.video]="article.url" ></att-gvp>
            </div>
        </app-accordion-list>
      </app-accordion>
    </div>
</section>
</div>
